import { render, staticRenderFns } from "./VegDialogForm.vue?vue&type=template&id=8b9a9f6e"
import script from "./VegDialogForm.vue?vue&type=script&lang=ts"
export * from "./VegDialogForm.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports